// extracted by extract-css-chunks-webpack-plugin
module.exports = {"latestNews":"_2WgTvl aLs3Nr","headingWrapper":"_3FOAAb","readmoreLink":"_3UoPFV"};